import { render, staticRenderFns } from "./block-rental-information.vue?vue&type=template&id=02afcbf4&scoped=true&"
import script from "./block-rental-information.vue?vue&type=script&lang=js&"
export * from "./block-rental-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02afcbf4",
  null
  
)

export default component.exports